import { mapToStopType, type TourStop } from '#components/tour/CreateTourDialog/TourStop.ts';
import { isServiceOrder, type OrderSummary } from '#domain/Order.ts';
import type { Stop } from '#domain/Stop.ts';

export const mapOrdersToOrderedTourStops = (selectedOrders: OrderSummary[], orderedStops: Stop[]) => {
    const stopTypeByStopId = new Map<string, TourStop>();

    selectedOrders.forEach((order, index) => {
        if (isServiceOrder(order)) {
            stopTypeByStopId.set(order.executionStop.id, mapToStopType(order, order.executionStop, 'execute', index));
            return;
        }
        stopTypeByStopId.set(order.loadingStop.id, mapToStopType(order, order.loadingStop, 'load', index));
        stopTypeByStopId.set(order.unloadingStop.id, mapToStopType(order, order.unloadingStop, 'unload', index));
    });

    return orderedStops.flatMap(stop => {
        const mappedStop = stopTypeByStopId.get(stop.id);
        if (!mappedStop) {
            return [];
        }
        return [mappedStop];
    });
};
